<template>
  <div v-show="dialogFormVisible" class="addClassBox">
    <div class="addClassBoxIn">
      <div class="header">
        <span class="title">{{ firstTitle }}</span>
        <i class="iconfont icon-guanbi" @click="close" />
      </div>
      <h6 class="secondTitle">
        {{ secondTitle }}
      </h6>
      <div class="input">
        <el-input
          class="input"
          type="text"
          v-model="inputValue"
          :maxlength="6"
          :placeholder="'请输入' + secondTitle"
        />
        <span class="countLength">{{ inputValue.length >= 6 ? '6' : inputValue.length }}/6</span>
      </div>
      <template v-if="thirdTitle">
        <h6 class="thirdTitle">
          {{ thirdTitle }}
        </h6>
        <div class="select">
          <el-select v-model="selectValue" filterable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.labelName"
              :value="item.id"
            />
          </el-select>
        </div>
      </template>
      <el-button class="button" type="primary" size="medium" @click="sure">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddTag',
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    firstTitle: {
      type: String,
      default: '添加标签',
    },
    secondTitle: {
      type: String,
      default: '产品推广',
    },
    thirdTitle: {
      type: String,
      default: '',
    },
    initInputValue: {
      type: String,
      default: '',
    },
    initSelectValue: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputValue: '',
      selectValue: '',
    };
  },
  watch: {
    dialogFormVisible(newVal) {
      if (newVal) {
        this.inputValue = this.initInputValue;
        this.selectValue = this.initSelectValue;
      } else {
        this.inputValue = '';
        this.selectValue = '';
      }
    },
  },
  methods: {
    close() {
      this.$emit('hideDialog');
    },
    sure() {
      if (!this.inputValue.trim()) {
        this.$message.warning(`请输入${this.secondTitle}`);
        return;
      }
      let buId = '';
      if (this.thirdTitle) {
        if (!this.selectValue) {
          this.$message.warning(`请选择${this.thirdTitle}`);
          return;
        }
        this.options.forEach((e) => {
          if (e.id == this.selectValue) {
            // 选择产品关联领域需要找出领域对应的buId
            buId = e.buId;
          }
        });
      }
      const query = {
        inputValue: this.inputValue.trim(),
        selectValue: this.selectValue,
        buId,
      };
      this.$emit('sureBtnEmit', query);
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
